import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { SimpleIcon } from './icon-utils';

export function DriveIcon(props: SimpleIconInterface): JSX.Element {
  const { className, ...rest } = props;

  return (
    <SimpleIcon
      className={className}
      fill="none"
      height="16"
      viewBoxDimensions="0 0 17 16"
      width="17"
      {...rest}
    >
      <path
        d="M13.9017 1.33626C14.2378 1.37048 14.5 1.65455 14.5 1.99967V13.9997C14.5 14.3679 14.2015 14.6663 13.8333 14.6663H3.16667C2.79848 14.6663 2.5 14.3679 2.5 13.9997V1.99967L2.50325 1.93131C2.53747 1.59523 2.82155 1.33301 3.16667 1.33301H13.8333L13.9017 1.33626ZM3.83333 10.6663V13.333H13.1667V10.6663H3.83333ZM5.83333 12.6663H4.5V11.333H5.83333V12.6663ZM3.83333 9.33301H13.1667V6.66634H3.83333V9.33301ZM5.83333 8.66634H4.5V7.33301H5.83333V8.66634ZM3.83333 5.33301H13.1667V2.66634H3.83333V5.33301ZM5.83333 4.66634H4.5V3.33301H5.83333V4.66634Z"
        fill="#324A52"
      />
    </SimpleIcon>
  );
}
